import { Linkable } from '@/components/blocks/Linkable';
import { styledAccordionDetailsSx } from '@/components/content/Footer/parts/FooterCardEspots/styles/AccordionDetails/styledAccordionDetails';
import { styledAccordionDetailsHDMSx } from '@/components/content/Footer/parts/FooterCardEspots/styles/AccordionDetails/styledAccordionDetailsHDM';
import { styledAccordionSummarySx } from '@/components/content/Footer/parts/FooterCardEspots/styles/AccordionSummary/styledAccordionSummary';
import { styledBoxSx } from '@/components/content/Footer/parts/FooterCardEspots/styles/Box/styledBox';
import { styledGridSx } from '@/components/content/Footer/parts/FooterCardEspots/styles/Grid/styledGrid';
import { listItemStylesSx } from '@/components/content/Footer/parts/FooterCardEspots/styles/ListItem/listItemStyles';
import { styledTypographySx } from '@/components/content/Footer/parts/FooterCardEspots/styles/Typography/styledTypography';
import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { JsonEspotResponseType } from '@/data/utils/dataMapContent';
import { combineSX } from '@/utils/combineSX';
import { ExpandMore } from '@mui/icons-material';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Grid,
	ListItem,
	ListItemText,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';

export const FooterCardESpot = ({ emsName }: { emsName: string }) => {
	const { jsonEspotData } = useContentRecommendation(emsName, true);
	const data = jsonEspotData as JsonEspotResponseType;
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
	const [expandedAccordion, setExpandedAccordion] = useState(isDesktop);

	const handleChange = () => {
		setExpandedAccordion((prev) => !prev);
	};

	useEffect(() => {
		setExpandedAccordion(isDesktop);
	}, [isDesktop]);

	return (
		<Grid item xs={12} md={3} sx={styledGridSx}>
			<Accordion
				expanded={expandedAccordion}
				onChange={handleChange}
				square={false}
				sx={{ minHeight: '100%' }}
			>
				<AccordionSummary
					disableRipple={true}
					sx={styledAccordionSummarySx}
					expandIcon={<ExpandMore sx={{ color: '#f96302' }} />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography sx={styledTypographySx} variant={'headingSubtitle'}>
						{data?.title}
					</Typography>
				</AccordionSummary>
				<Box sx={styledBoxSx}>
					<AccordionDetails sx={combineSX([styledAccordionDetailsSx, styledAccordionDetailsHDMSx])}>
						{data?.contents?.map((content, index) => (
							<ListItem key={index} sx={listItemStylesSx}>
								<ListItemText
									primary={
										<Typography sx={styledTypographySx} variant={'bodyBaseline'}>
											{content.url?.includes('http') && !content.url?.includes('tel') ? (
												<a
													rel="noopener noreferrer"
													key={content.title}
													href={content.url}
													target="_blank"
												>
													{content.title}
												</a>
											) : content.url?.includes('tel') ? (
												<a href={content?.url.replace(/-/g, '')}>{content?.title}</a>
											) : (
												<Linkable id={content.title} href={content.url}>
													{content.title}
												</Linkable>
											)}
										</Typography>
									}
								/>
							</ListItem>
						))}
					</AccordionDetails>
				</Box>
			</Accordion>
		</Grid>
	);
};
